 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import A781590207048 from '@/components/9781590207048'
 import LOVE_1 from '@/components/love_1'
 import A7815902070481 from '@/components/9781590207048-1'
 import A7815902070482 from '@/components/9781590207048-2'
 import TOC from '@/components/toc'
 import A7815902070483 from '@/components/9781590207048-3'
 import A7815902070484 from '@/components/9781590207048-4'
 import A7815902070485 from '@/components/9781590207048-5'
 import A7815902070486 from '@/components/9781590207048-6'
 import A7815902070487 from '@/components/9781590207048-7'
 import A7815902070488 from '@/components/9781590207048-8'
 import A7815902070489 from '@/components/9781590207048-9'
 import A78159020704810 from '@/components/9781590207048-10'
 import A78159020704811 from '@/components/9781590207048-11'
 import A78159020704812 from '@/components/9781590207048-12'
 import A78159020704813 from '@/components/9781590207048-13'
 import A78159020704814 from '@/components/9781590207048-14'
 import A78159020704815 from '@/components/9781590207048-15'
 import A78159020704816 from '@/components/9781590207048-16'
 import A78159020704817 from '@/components/9781590207048-17'
 import A78159020704818 from '@/components/9781590207048-18'
 import A78159020704819 from '@/components/9781590207048-19'
 import A78159020704820 from '@/components/9781590207048-20'
 import A78159020704821 from '@/components/9781590207048-21'
 import A78159020704822 from '@/components/9781590207048-22'
 import A78159020704823 from '@/components/9781590207048-23'
 import A78159020704824 from '@/components/9781590207048-24'
 import A78159020704825 from '@/components/9781590207048-25'
 import A78159020704826 from '@/components/9781590207048-26'
 import A78159020704827 from '@/components/9781590207048-27'
 import A78159020704828 from '@/components/9781590207048-28'
 import A78159020704829 from '@/components/9781590207048-29'
 import A78159020704830 from '@/components/9781590207048-30'
 import A78159020704831 from '@/components/9781590207048-31'
 import A78159020704832 from '@/components/9781590207048-32'
 import A78159020704833 from '@/components/9781590207048-33'
 import A78159020704834 from '@/components/9781590207048-34'
 import A78159020704835 from '@/components/9781590207048-35'
 import A78159020704836 from '@/components/9781590207048-36'
 import A78159020704837 from '@/components/9781590207048-37'
 import A78159020704838 from '@/components/9781590207048-38'
 import A78159020704839 from '@/components/9781590207048-39'
 import A78159020704840 from '@/components/9781590207048-40'
 import A78159020704841 from '@/components/9781590207048-41'
 import A78159020704842 from '@/components/9781590207048-42'
 import A78159020704843 from '@/components/9781590207048-43'
 import A78159020704844 from '@/components/9781590207048-44'
 import A78159020704845 from '@/components/9781590207048-45'
 import A78159020704846 from '@/components/9781590207048-46'
 import A78159020704847 from '@/components/9781590207048-47'
 import A78159020704848 from '@/components/9781590207048-48'
 import A78159020704849 from '@/components/9781590207048-49'
 import A78159020704850 from '@/components/9781590207048-50'
 import A78159020704851 from '@/components/9781590207048-51'
 import A78159020704852 from '@/components/9781590207048-52'
 import A78159020704853 from '@/components/9781590207048-53'
 import A78159020704854 from '@/components/9781590207048-54'
 import A78159020704855 from '@/components/9781590207048-55'
 import A78159020704856 from '@/components/9781590207048-56'
 import A78159020704857 from '@/components/9781590207048-57'
 import A78159020704858 from '@/components/9781590207048-58'
 import A78159020704859 from '@/components/9781590207048-59'
 import A78159020704860 from '@/components/9781590207048-60'
 import A78159020704861 from '@/components/9781590207048-61'
 import A78159020704862 from '@/components/9781590207048-62'
 import A78159020704863 from '@/components/9781590207048-63'
 import A78159020704864 from '@/components/9781590207048-64'
 import A78159020704865 from '@/components/9781590207048-65'
 import A78159020704866 from '@/components/9781590207048-66'
 import A78159020704867 from '@/components/9781590207048-67'
 import A78159020704868 from '@/components/9781590207048-68'
 import A78159020704869 from '@/components/9781590207048-69'
 import A78159020704870 from '@/components/9781590207048-70'
 import A78159020704871 from '@/components/9781590207048-71'
 import A78159020704872 from '@/components/9781590207048-72'
 import A78159020704873 from '@/components/9781590207048-73'
 import A78159020704874 from '@/components/9781590207048-74'
 import A78159020704875 from '@/components/9781590207048-75'
 import A78159020704876 from '@/components/9781590207048-76'
 import A78159020704877 from '@/components/9781590207048-77'
 import A78159020704878 from '@/components/9781590207048-78'
 import A78159020704879 from '@/components/9781590207048-79'
 import A78159020704880 from '@/components/9781590207048-80'
 import A78159020704881 from '@/components/9781590207048-81'
 import A78159020704882 from '@/components/9781590207048-82'
 import A78159020704883 from '@/components/9781590207048-83'
 import A78159020704884 from '@/components/9781590207048-84'
 import A78159020704885 from '@/components/9781590207048-85'
 import A78159020704886 from '@/components/9781590207048-86'
 import A78159020704887 from '@/components/9781590207048-87'
 import A78159020704888 from '@/components/9781590207048-88'
 import A78159020704889 from '@/components/9781590207048-89'
 import A78159020704890 from '@/components/9781590207048-90'
 import A78159020704891 from '@/components/9781590207048-91'
 import A78159020704892 from '@/components/9781590207048-92'
 import A78159020704893 from '@/components/9781590207048-93'
 import LOVE_2 from '@/components/love_2'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/toc",
 			"name" : "toc",
 			"component" : TOC
 		},
 		{
 			"path" : "/9781590207048-3",
 			"name" : "9781590207048-3",
 			"component" : A7815902070483
 		},
 		{
 			"path" : "/9781590207048-4",
 			"name" : "9781590207048-4",
 			"component" : A7815902070484
 		},
 		{
 			"path" : "/9781590207048-5",
 			"name" : "9781590207048-5",
 			"component" : A7815902070485
 		},
 		{
 			"path" : "/9781590207048-6",
 			"name" : "9781590207048-6",
 			"component" : A7815902070486
 		},
 		{
 			"path" : "/9781590207048-7",
 			"name" : "9781590207048-7",
 			"component" : A7815902070487
 		},
 		{
 			"path" : "/9781590207048-8",
 			"name" : "9781590207048-8",
 			"component" : A7815902070488
 		},
 		{
 			"path" : "/9781590207048-9",
 			"name" : "9781590207048-9",
 			"component" : A7815902070489
 		},
 		{
 			"path" : "/9781590207048-10",
 			"name" : "9781590207048-10",
 			"component" : A78159020704810
 		},
 		{
 			"path" : "/9781590207048-11",
 			"name" : "9781590207048-11",
 			"component" : A78159020704811
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js